import React from 'react'
import { Box, Heading, Stack, Text } from '@thirstycamel/ui'
import { useActions } from '../../store/hooks'

export interface MissedSavingsBannerProps {
  totalDiscountAmount: number // cents
  variant?: 'small' | 'large'
  signInVariant?: 'popout' | 'modal'
}

export const MissedSavingsBanner = ({
  totalDiscountAmount,
  variant = 'large',
  signInVariant = 'popout',
}: MissedSavingsBannerProps) => {
  const hidePopout = useActions(actions => actions.cart.hidePopout)
  const openLoginPopout = useActions(actions => actions.auth.openLoginPopout)
  const showModal = useActions(actions => actions.modal.showModal)

  if (!totalDiscountAmount || totalDiscountAmount <= 0) return null

  const labelFontSize = variant === 'small' ? 'xs' : 'sm'
  const ctaFontSize = variant === 'small' ? 'sm' : 'md'

  return (
    <Box
      bg="green.50"
      p={3}
      borderRadius="md"
      border="1px solid"
      borderColor="green.200"
      textAlign="center"
    >
      <Stack spacing={0.5}>
        <Heading fontSize={labelFontSize} color="green.700" textTransform="uppercase">
          You could be saving{'  '}
          <Box as="span" color="pink.500" transform="translateY(-2px)">
            ${(totalDiscountAmount / 100).toFixed(2)}
          </Box>
        </Heading>

        <Text
          fontSize={ctaFontSize}
          fontFamily="heading"
          textTransform="uppercase"
          color="blackAlpha.700"
        >
          <Text
            as="button"
            onClick={() => {
              hidePopout()
              showModal({ name: 'SIGNUP_TO_SAVE' })
            }}
            color="pink.500"
            fontWeight="bold"
            background="transparent"
            border="0"
            p={0}
            cursor="pointer"
            fontFamily="heading"
            textTransform="uppercase"
            display="inline"
          >
            Sign up
          </Text>{' '}
          or{' '}
          <Text
            as="button"
            onClick={() => {
              hidePopout()
              if (signInVariant === 'modal') {
                showModal({ name: 'SIGNIN_TO_SAVE' })
              } else {
                openLoginPopout()
              }
            }}
            color="pink.500"
            fontWeight="bold"
            background="transparent"
            border="0"
            p={0}
            cursor="pointer"
            fontFamily="heading"
            textTransform="uppercase"
            display="inline"
          >
            sign in
          </Text>{' '}
          to unlock member prices
        </Text>
      </Stack>
    </Box>
  )
}

export default MissedSavingsBanner
